// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"cdb11fb9","787":"ebe20228"}[chunkId] + ".chunk.js";
};